





























import {
  Vue, Component, Watch,
} from 'vue-property-decorator';
import OnboardingDropdown from '@/components/Stats/OnboardingStats/OnboardingDropdown/index.vue';
import OnboardingTable from '@/components/Stats/OnboardingStats/OnboardingTable/index.vue';
import OnboardingUnitTable from '@/components/Stats/OnboardingStats/OnboardingUnitTable/index.vue';
import moment from 'moment';
import StatsUtil from '@/util/StatsUtil';
import UserModule from '@/store/modules/user';
import ToastModule from '@/store/modules/toast';

@Component({
  components: {
    OnboardingDropdown,
    OnboardingTable,
    OnboardingUnitTable,
  },
})
export default class OnboardingStats extends Vue {
  public selectDays: string = moment().subtract(7, 'days').format();

  public marketsArr: any[] = [];

  public searchMarket: any = '';

  public loading: boolean = false;

  public onBoardingStats: any = [];

  public onBoardingItems: any = [];

  public onboardCounts: any = {};

  public onboardDateRange: string = '';

  public onboardFullDateRange: string = '';

  @Watch('searchMarket', { immediate: true })
  marketSelected(val: any) {
    this.getFilteredOnboardStats(val);
  }

  @Watch('selectDays', { immediate: true })
  daysSelected(val: any) {
    this.getFilteredOnboardStats(this.searchMarket);
  }

  @Watch('onboardFullDateRange', { immediate: true })
  timeframeSelected(val: any) {
    this.getFilteredOnboardStats(this.searchMarket);
  }

  public getFilteredOnboardStats(marketIds: Array<string>) {
    let countOnboardStats;
    if (marketIds.length > 0) {
      const marketsS = marketIds;
      const filteredPartners = this.onBoardingStats.partners
        .filter((evt: any) => marketsS.includes(evt.market?.id));
      const filteredUnits = this.onBoardingStats.units
        .filter((evt: any) => marketsS.includes(evt.market?.id));
      if (this.onboardFullDateRange) {
        const prevDate = moment(this.onboardFullDateRange.split(' - ')[0]).format('YYYY-MM-DD');
        const nextDate = moment(this.onboardFullDateRange.split(' - ')[1]).format('YYYY-MM-DD');
        countOnboardStats = StatsUtil.getOnBoardingCounts(
          {
            partners: filteredPartners,
            units: filteredUnits,
          },
          prevDate,
          nextDate,
          true,
        );
      } else {
        countOnboardStats = StatsUtil.getOnBoardingCounts(
          {
            partners: filteredPartners,
            units: filteredUnits,
          },
          this.selectDays,
          '',
          false,
        );
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (this.onboardFullDateRange) {
        const prevDate = moment(this.onboardFullDateRange.split(' - ')[0]).format('YYYY-MM-DD');
        const nextDate = moment(this.onboardFullDateRange.split(' - ')[1]).format('YYYY-MM-DD');
        countOnboardStats = StatsUtil.getOnBoardingCounts(
          this.onBoardingStats,
          prevDate,
          nextDate,
          true,
        );
      } else {
        countOnboardStats = StatsUtil.getOnBoardingCounts(
          this.onBoardingStats,
          this.selectDays,
          '',
          false,
        );
      }
    }
    this.onBoardingItems = countOnboardStats.filteredOnboardStats;
    this.onboardCounts = countOnboardStats;
  }

  public async mounted() {
    // await this.getPartnersUnits();
    await this.accessAdminUser();
  }

  public beforeRouteEnter(to: any, from: any, next: any) {
    next(async (vm: any) => {
      if (from.name === 'loading') {
        await vm.getNewPartnersUnits();
      } else {
        await vm.getPartnersUnits();
      }
    });
  }

  public async getNewPartnersUnits() {
    this.loading = true;
    const localPartners = localStorage.getItem('partners');
    const localUnits = localStorage.getItem('units');
    const partnerItems = JSON.parse(localPartners as any);
    const unitItems = JSON.parse(localUnits as any);
    if (partnerItems || unitItems) {
      localStorage.removeItem('partners');
      localStorage.removeItem('units');
    }
    await this.getCommonPartnersUnits();
  }

  public async getCommonPartnersUnits() {
    try {
      this.loading = true;
      const partners = await StatsUtil.getPartners();
      const units = await StatsUtil.getUnits();
      if (partners.length > 0 || units.length > 0) {
        const partnersUnits = {
          partners,
          units,
        };
        const mappedPartnersUnits = await StatsUtil.getMappedPartnersUnits(partnersUnits);
        this.onBoardingStats = mappedPartnersUnits;
        const countOnboardStats = StatsUtil.getOnBoardingCounts(
          mappedPartnersUnits,
          this.selectDays,
          '',
          false,
        );
        this.onBoardingItems = countOnboardStats.filteredOnboardStats;
        this.onboardCounts = countOnboardStats;
      }
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message,
          timeout: 5000,
        });
      }
    }
    this.loading = false;
  }

  public async getPartnersUnits() {
    await this.getCommonPartnersUnits();
  }

  public onChangeDays() {
    const nextDate = '';
    const countOnboardStats = StatsUtil.getOnBoardingCounts(
      this.onBoardingStats,
      this.selectDays,
      nextDate,
      false,
    );
    this.onBoardingItems = countOnboardStats.filteredOnboardStats;
    this.onboardCounts = countOnboardStats;
    this.onboardDateRange = '';
    this.onboardFullDateRange = '';
  }

  public onChangeCustomDate(prevDate: string, nextDate: string) {
    const countOnboardStats = StatsUtil.getOnBoardingCounts(
      this.onBoardingStats,
      prevDate,
      nextDate,
      true,
    );
    this.onboardDateRange = `${moment(prevDate).format('MMMM D, YYYY')} - ${moment(nextDate).format('MMMM D, YYYY')}`;
    this.onboardFullDateRange = `${moment(prevDate).format('YYYY-MM-DD')} - ${moment(nextDate).format('YYYY-MM-DD')}`;
    this.onBoardingItems = countOnboardStats.filteredOnboardStats;
    this.onboardCounts = countOnboardStats;
  }

  public async accessAdminUser() {
    if (UserModule.currentRole === 'fw_manager'
      || UserModule.currentRole === 'fw_admin') {
      const marketsArrs = await StatsUtil.acessMarkets();
      if (marketsArrs) {
        this.marketsArr = marketsArrs;
      }
    }
    return null;
  }
}
